/**
 * CreateBookingModalFields — the "New booking" form body (BON-142, designs
 * 01/03). Thin composition of the section files: Workshop, Customer,
 * Payment, Money. Split this way so no single file trips the repo's line cap.
 */
import { CreateBookingCustomerFields } from './CreateBookingCustomerFields';
import type { MoneySummary, PaymentMode, PickedWorkshop } from './CreateBookingModalHelpers';
import { CreateBookingMoneySection } from './CreateBookingMoneySection';
import { PaymentFields } from './CreateBookingPaymentFields';
import { CreateBookingSectionHeader } from './CreateBookingSectionHeader';
import { WorkshopCard, WorkshopCta } from './CreateBookingWorkshopFields';

export interface CreateBookingFieldsProps {
  workshop: PickedWorkshop | null;
  onOpenPicker: () => void;
  fullName: string;
  setFullName: (v: string) => void;
  email: string;
  setEmail: (v: string) => void;
  tickets: number;
  setTickets: (v: number) => void;
  setAllTickets: () => void;
  mode: PaymentMode;
  setMode: (v: PaymentMode) => void;
  reason: string;
  setReason: (v: string) => void;
  canComp: boolean;
  money: MoneySummary;
}

export function CreateBookingModalFields(props: CreateBookingFieldsProps) {
  return (
    <>
      <div>
        <CreateBookingSectionHeader>Workshop</CreateBookingSectionHeader>
        {props.workshop ? (
          <WorkshopCard workshop={props.workshop} onOpenPicker={props.onOpenPicker} />
        ) : (
          <WorkshopCta onOpenPicker={props.onOpenPicker} />
        )}
      </div>

      <div>
        <CreateBookingSectionHeader>Customer</CreateBookingSectionHeader>
        <CreateBookingCustomerFields
          fullName={props.fullName}
          setFullName={props.setFullName}
          email={props.email}
          setEmail={props.setEmail}
          tickets={props.tickets}
          setTickets={props.setTickets}
          setAllTickets={props.setAllTickets}
          ticketsMax={props.workshop ? Math.max(props.workshop.seatsLeft, 1) : null}
        />
      </div>

      <PaymentFields
        mode={props.mode}
        setMode={props.setMode}
        reason={props.reason}
        setReason={props.setReason}
        canComp={props.canComp}
      />

      <CreateBookingMoneySection money={props.money} />
    </>
  );
}
